import React from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import { Input } from '../ui/input';

export interface FormattedNumberInputProps
    extends Omit<NumericFormatProps, 'value' | 'onValueChange'> {
    value?: number;
    onValueChange?: (value?: number) => void;
}

export function FormattedNumberInput({
    value,
    onValueChange,
    ...props
}: FormattedNumberInputProps) {
    return (
        <NumericFormat
            value={value}
            onValueChange={(values) => {
                onValueChange?.(values.floatValue);
            }}
            customInput={Input}
            thousandSeparator="."
            decimalSeparator=","
            allowedDecimalSeparators={[',', '.']}
            {...props}
        />
    );
}
